import classNames from 'classnames'
import { observer } from 'mobx-react'
import { useEffect, useState } from 'react'
import ContentState from '../../../../stores/ContentState'
import CustomSlider from '../../../common/CustomSlider'
import './index.scss'
const DNK = observer(() => {
  const [tab, setTab] = useState(0)
  const [width, setWidth] = useState(window.innerWidth)

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 300,
    variableWidth: true,
  }

  useEffect(() => {
    window.addEventListener('resize', () => setWidth(window.innerWidth))
  }, [])

  if (!ContentState.career.dnk) return <></>
  const dnk = ContentState.career.dnk

  return (
    <section className="career-dnk">
      <div className="career-dnk__title">{dnk.title}</div>
      <div className="career-dnk__row">
        <div className="career-dnk__tabs">
          {dnk.list
            .map((l: any) => l.title)
            .map((l: any, i: number) => (
              <div
                onClick={() => setTab(i)}
                className={classNames('career-dnk__tab', tab == i && 'active')}
                key={i}
              >
                <span className="career-dnk__tab-num">0{i + 1}</span>{' '}
                <div className="career-dnk__tab-title">{l}</div>
              </div>
            ))}
        </div>
        <div className="career-dnk__content">
          {dnk.list.map((l: any, i: number) => (
            <div
              className={classNames(
                'career-dnk__content-item',
                i == tab && 'active',
              )}
              key={i}
            >
              <div className="career-dnk__content-img">
                <img src={l.src} />
              </div>
              <div className="career-dnk__content-col">
                <div className="career-dnk__content-title">{l.title}</div>
                <div
                  className="career-dnk__content-text"
                  dangerouslySetInnerHTML={{ __html: l.text }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="career-dnk__slider">
        <CustomSlider
          count={dnk.list.length}
          settings={{
            ...settings,
            slidesToShow: width > 990 ? 2 : 1,
            slidesToScroll: width > 990 ? 2 : 1,
          }}
        >
          {dnk.list.map((s: any, i: number) => (
            <div className="career-dnk__slider-slide" key={i}>
              <div className="career-dnk__slider-img">
                <img src={s.src} />
              </div>
              <div className="career-dnk__slider-content">
                <div className="career-dnk__slider-title">{s.title}</div>
                <div
                  className="career-dnk__slider-text"
                  dangerouslySetInnerHTML={{ __html: s.text }}
                ></div>
              </div>
            </div>
          ))}
        </CustomSlider>
      </div>
    </section>
  )
})

export default DNK
